import React from 'react';
import processBg from '../../../assets/site/bg-process.jpg';
import Section from '../../site/components/Section';
import SectionHead from '../../site/components/SectionHead';
import { processSteps } from '../../site/data/content';
import cx from '../../site/utils/cx';
import ui from '../../site/styles/primitives.module.css';
import styles from './InvestmentProcess.module.css';

const InvestmentProcess = () => (
  <Section id="process" background={processBg} backgroundPosition="center 45%">
    <div className={ui.wrap}>
      <SectionHead eyebrow="Our 3-step process" title="From first call to" highlight="first building" />
      <ol className={styles.steps}>
        {processSteps.map((step, index) => (
          <li key={step.title} className={cx(styles.step, index % 2 === 0 ? ui.glass : ui.matte)} data-reveal="">
            <span className={cx(styles.number, ui.grad)} aria-hidden="true">
              {index + 1}
            </span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </li>
        ))}
      </ol>
    </div>
  </Section>
);

export default InvestmentProcess;
